export default __webpack_public_path__ + "static/StoriesStar-11de048423a95c55d376ddbde00a502d.svg";